/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringListResult } from '../../models/string-list-result';

export interface ApiPlayerPositionsGet$JsonOdataMetadataNone$Params {
}

export function apiPlayerPositionsGet$JsonOdataMetadataNone(http: HttpClient, rootUrl: string, params?: ApiPlayerPositionsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerPositionsGet$JsonOdataMetadataNone.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringListResult>;
    })
  );
}

apiPlayerPositionsGet$JsonOdataMetadataNone.PATH = '/api/player/positions';
